const JsScrollTo = {
	init () {

		if ( $('.js-scroll').length ) {
			// Scroll to section
			$('.js-scroll').click(function () {
				if (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && location.hostname === this.hostname) {

					var target = $(this.hash);
					target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');

					if (target.length) {
						$('html,body').animate({
						// the 100 is a fixed header offset
							scrollTop: target.offset().top - 100
						}, 500);
						return false;
					}
				}
			});
		} 
	}
};

export default JsScrollTo;


// WEBPACK FOOTER //
// ./src/js/aras-kids-modules/smooth-scroll-to.js